import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Spinner,
} from "@fluentui/react-components";
import Button from "./Button";

type ConfirmationFormProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  dialogTitle: string;
  dialogContent: string;
  confirmButtonLabel?: string;
  confirmingButtonLabel?: string;
  cancelButtonLabel?: string;
  dismissButtonLabel?: string;
  isConfirming?: boolean;
  confirmButtonDisabled?: boolean;
  cancelButtonDisabled?: boolean;
  onDismiss?: () => void;
};

const ConfirmationForm: React.FC<ConfirmationFormProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  dialogTitle,
  dialogContent,
  confirmButtonLabel = "OK",
  confirmingButtonLabel = "Executing...",
  cancelButtonLabel = "Cancel",
  dismissButtonLabel,
  isConfirming = false,
  confirmButtonDisabled = false,
  cancelButtonDisabled = false,
  onDismiss,
}) => {
  return (
    <Dialog open={isOpen}>
      <DialogSurface style={{ margin: "16px" }}>
        <DialogBody>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent>{dialogContent}</DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button
                label={isConfirming ? confirmingButtonLabel : confirmButtonLabel}
                icon={isConfirming ? <Spinner size="tiny" /> : undefined}
                onClick={onConfirm}
                disabled={confirmButtonDisabled || isConfirming}
              />
            </DialogTrigger>
            {cancelButtonLabel && onCancel && (
              <DialogTrigger disableButtonEnhancement>
                <Button label={cancelButtonLabel} onClick={onCancel} disabled={cancelButtonDisabled || isConfirming} />
              </DialogTrigger>
            )}
            {dismissButtonLabel && onDismiss && (
              <DialogTrigger disableButtonEnhancement>
                <Button label={dismissButtonLabel} onClick={onDismiss} disabled={cancelButtonDisabled || isConfirming} />
              </DialogTrigger>
            )}
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ConfirmationForm;
